export default __webpack_public_path__ + "static/media/Elletric 80.3338e727.png";